module.exports = __webpack_public_path__ + "img/add-photo.66c6807b.png";